<template>
  <div class="sm-account-cont" v-if="userAccount">
    <account-upper />
    <account-main />
  </div>
  <sm-spinner v-else :show="!userAccount" />
</template>

<script>
import Upper from '@/views/customer/pages/account/Upper.vue';
import Main from '@/views/customer/pages/account/Main.vue';
import { mapActions, mapGetters } from 'vuex';
import Spinner from '@/components/Spinner';

export default {
  name: 'account',
  components: {
    'account-upper': Upper,
    'account-main': Main,
    "sm-spinner": Spinner,
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
    })
  },
  created() {
    Promise.all([
      this.getUserAccount(),
      this.getUserPlan(true)
    ])
      .then(([acc, plan]) => {
        
      });
  },
  methods: {
    ...mapActions({
      getUserAccount: "account/userData",
      getUserPlan: "account/getUserPlan"
    })
  }
}
</script>

<style lang="scss">
  .sm-account-cont {
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      pointer-events: none;
      opacity: 0;
      transition: opacity .2s linear;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255,255,255, .6);
    }

    &.js-popup-show {
      &::after {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
</style>
